module.exports = __webpack_public_path__ + "static/img/invite-code-retain-modal.e0ae707.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/welfare/invite-code-retain-modal.png
// module id = qTen
// module chunks = 213